import OnboardingNotifications from '../../../onboarding/components/OnboardingNotifications';

export default function OnboardingNotificationsScreen() {
    return <OnboardingNotifications />;
}
